import React, { useState } from "react";
import { Row, Col, Container, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { loginUser } from "../../apis/Auth";
import { toast } from "react-toastify";
import logodark from "../../assets/images/logo_ghorfatech_dark.png";
import logolight from "../../assets/images/logo_ghorfatech.png";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear previous errors
    setErrors({ email: "", password: "" });

    // Validate input fields
    let hasError = false;
    const newErrors = { email: "", password: "" };

    if (!email) {
      newErrors.email = "Email is required.";
      hasError = true;
    }
    if (!password) {
      newErrors.password = "Password is required.";
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await loginUser(email, password, "admin");

      if (response?.data.success && response?.data?.data?.token) {
        const accessToken = response.data.data.token.replace("Bearer ", "");
        localStorage.setItem("token", accessToken);
        await refreshUser();
        toast.success("Logged in  Successfully");
        navigate("/");
      } else {
        toast.error("Login failed. Token not found.");
      }
    } catch (error) {
      console.error("Login error:", error); // Log error for debugging
      toast.error("Login failed. Please try again.");
    }
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={6}>
              <div className="authentication-bg bg-white w-1/3">
                <div className="bg-white opacity-5 bg-overlay w-full h-full"></div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="authentication-page-content bg-gray-50 p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={9}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="/" className="">
                              <img
                                src={logodark}
                                alt=""
                                height="20"
                                className="auth-logo w-1/2 h-1/2 max-h-[120px] max-w-[240px] logo-dark mx-auto"
                              />
                              <img
                                src={logolight}
                                alt=""
                                height="20"
                                className="auth-logo w-1/2 h-1/2 max-h-[120px] max-w-[240px] logo-light mx-auto"
                              />
                            </Link>
                          </div>
                          <h4 className="text-4xl font-bold mt-4">
                            Welcome Back!
                          </h4>
                          <p className="text-muted">
                            Sign in to continue to Ghorfatech.
                          </p>
                        </div>
                        <div className="p-2 mt-5">
                          <form
                            className="form-horizontal"
                            onSubmit={handleSubmit}
                          >
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-user-2-line auti-custom-input-icon !text-[#2C32E2]"></i>
                              <Label htmlFor="username">Email</Label>
                              <input
                                name="email"
                                value={email}
                                type="email"
                                className="form-control"
                                placeholder="Enter email"
                                onChange={(e) => setEmail(e.target.value)}
                              />
                              {errors.email && (
                                <p className="text-red-500 text-sm">
                                  {errors.email}
                                </p>
                              )}
                            </div>

                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-lock-2-line auti-custom-input-icon !text-[#2C32E2]"></i>
                              <Label htmlFor="userpassword">Password</Label>
                              <input
                                value={password}
                                type="password"
                                className="form-control"
                                placeholder="Enter password"
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              {errors.password && (
                                <p className="text-red-500 text-sm">
                                  {errors.password}
                                </p>
                              )}
                            </div>

                            <div className="mt-4 text-center">
                              <button
                                className="w-md w-full font-bold text-lg md:text-xl rounded-md py-1 text-white waves-effect waves-light bg-[#2C32E2]"
                                type="submit"
                              >
                                Log In
                              </button>
                            </div>

                            <div className="mt-4 text-center">
                              <Link
                                to="/forgot-password"
                                className="text-muted"
                              >
                                <i className="mdi mdi-lock me-1"></i> Forgot
                                your password?
                              </Link>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;
